import React from 'react'
import CustomButton from '../components/CustomButton'
import { useStyles } from '../components/PendingOfferCustomerStyle'
import { useDispatch } from 'react-redux'
import { acceptOffer } from '../store'

const PendingOfferCustomer = ({ application }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleAcceptOffer = () => {
    dispatch(acceptOffer({ accepted: true }));
  }

  const handleRejectOffer = () => {
    dispatch(acceptOffer({ accepted: false }));
  }

  return (
    <div className={classes.pendingOfferContainer}>
      <div className={classes.notificationBox}>
        <h3 className={classes.notificationTitle}>Change in Your Application</h3>
        <p className={classes.notificationText}>Dear customer, there has been a change in the amount you originally requested.</p>
        <p className={classes.notificationText}>
          The approved amount for your credit line is: <strong className={classes.amountHighlight}>${application?.limitDetails?.approved || '0.00'}</strong>
        </p>
        <p className={classes.notificationText}>Please review and confirm if you would like to accept this offer.</p>
      </div>

      <div className={classes.actionButtons}>
        <CustomButton
          onClick={handleAcceptOffer}
          className={classes.acceptButton}
          title="Accept Offer"
        />
        <CustomButton
          onClick={handleRejectOffer}
          className={classes.rejectButton}
          title="Reject Offer"
          variant="secondary"
        />
      </div>
    </div>
  )
}

export default PendingOfferCustomer
